import React, { useState, useEffect } from 'react';

const TopArrow = () => {
  const [isVisible, setIsVisible] = useState(false);

   const toggleVisibility = () => {
    if (window.scrollY > 200) {
      setIsVisible(true);
    } else {
      setIsVisible(false);
    }
  };

   const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  useEffect(() => {
    window.addEventListener('scroll', toggleVisibility);
    return () => {
      window.removeEventListener('scroll', toggleVisibility);
    };
  }, []);

  return (
    <div className="fixed bottom-32 right-4">
      {isVisible && (
        <button
          onClick={scrollToTop}
          className="bg-blue-500 text-white p-3 w-11 h-11 rounded-full shadow-lg hover:bg-red-700 transition duration-300 flex items-center justify-center text-lg"
        >
          ↑
        </button>
      )}
    </div>
  );
};

export default TopArrow;
